import { TransformRule } from "../transformation/TransformRule";
import { BaseFieldConfig, BaseFieldConfigData } from "./BaseFieldConfig";
import { HeliosDocFieldConfig } from "./helios/DocFieldConfig";

export { DocFieldConfig, DocFieldConfigData };

type DocFieldConfigData = BaseFieldConfigData & {
  helios?: HeliosDocFieldConfig;
};

class DocFieldConfig extends BaseFieldConfig {
  helios?: HeliosDocFieldConfig;

  constructor(data: DocFieldConfigData) {
    super(data);
    this.helios = data.helios;
  }

  setTransformRules(rules: TransformRule[]) {
    this.transformationRules = rules;
  }

  static createTest(rest: Partial<DocFieldConfigData> = {}): DocFieldConfig {
    const data: DocFieldConfigData = {
      fieldName: "",
      description: "",
      displayTab: "",
      threshold: this.DEFAULT_THRESHOLD,
      ocrConfidenceThreshold: this.DEFAULT_OCR_THRESHOLD,
      hidden: false,
      generateReuse: this.DEFAULT_GENERATE_REUSE,
      applyReuse: false,
      position: 0,
      validator: {
        clientValidationOperator: "OR",
        validationRules: [],
        fieldName: "",
      },
      transformationRules: [],
    };

    return new DocFieldConfig({
      ...data,
      ...rest,
    });
  }

  public toData(): DocFieldConfigData {
    return {
      helios: this.helios ? { ...this.helios } : undefined,
      generateReuse: this.generateReuse,
      applyReuse: this.applyReuse,
      fieldName: this.fieldName,
      description: this.description,
      position: this.position,
      displayTab: this.displayTab,
      threshold: this.threshold,
      ocrConfidenceThreshold: this.ocrConfidenceThreshold,
      hidden: this.hidden,
      validator: this.validator,
      transformationRules: this.transformationRules.map((x) => x.toData()),
    };
  }
}
